module.exports = __webpack_public_path__ + "img/facebook.9e8715c3.svg";